import { Suspense, lazy } from 'react';

import { Loading } from '../Loading';

import type { Props } from './types/props.type';

const Editor = lazy(() =>
  import('./index').then((module) => ({
    default: module.Editor,
  })),
);

export const LazyEditor = (props: Readonly<Props>) => (
  <Suspense fallback={<Loading />}>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <Editor {...props} />
  </Suspense>
);
